/**
 * Bottom-right jump button for touch devices. Visibility is CSS-driven,
 * matching the TouchJoystick (@media hover:none / pointer:coarse).
 */
export class JumpButton {
  constructor(elementId: string, onJump: () => void) {
    const el: HTMLElement | null = document.getElementById(elementId);
    if (el === null) {
      throw new Error(`JumpButton element #${elementId} not found`);
    }
    el.addEventListener(
      "touchstart",
      (e: TouchEvent) => {
        e.preventDefault();
        onJump();
      },
      { passive: false }
    );
  }
}
